
import { stateNameToAbbreviation } from './StateNameToAbbreviation';

function getKeysByValue(map, targetValue) {
    const keys = [];
    for (const key in map) {
      if (map[key] === targetValue) {
        keys.push(key);
      }
    }
    return keys;
  }

// Function to convert abbreviation to full state name
const stateAbbreviationToName = (abbreviation) => {
  return getKeysByValue(stateNameToAbbreviation, abbreviation)|| abbreviation;
};

export default stateAbbreviationToName;
